import { createSlice } from '@reduxjs/toolkit';

const stateSlice = createSlice({
	name: 'quickNotesPanel/state',
	initialState: false,
	reducers: {
		toggleQuickNotesPanel: state => !state,
		openQuickNotesPanel: state => true,
		closeQuickNotesPanel: state => false
	}
});

export const { toggleQuickNotesPanel, openQuickNotesPanel, closeQuickNotesPanel } = stateSlice.actions;

export default stateSlice.reducer;
